/* The invitation page: one centred card, as the v3 mockup's `.auth-card` (440px wide at most). */
.page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-block-size: 100vh;
  padding: 2rem 1rem;
  background-color: var(--surface);
}

.card {
  inline-size: min(440px, 100%);
  padding: var(--space-6);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background-color: var(--surface-raised);
}
